// src/utils/appEffect.ts
import { isElectron } from '@libs/utils/envUtils'
import i18n from '@/languages/i18n'
import { trackUserActivity } from '@/activitylog/activitylog'

export function trackWebActivity() {
  if (import.meta.env.PROD == false) return
  if (isElectron()) return
  if (i18n.global.locale == 'zh') {
    trackUserActivity()
  }
}
